import { type LandingPageCustom, landing_page_custom } from '../../utils/requests/contentstack/contentStackZodSchema';
import { businessLineCarouselSchema } from '../BusinessLineCarousel/schema';
import { seoDataSchema } from '../SEOData';
import { imageHalfScreenHeroSchema } from '../ImageHalfScreenHero/schema';
import { contentGallerySchema } from '../ContentGallery';
import { dividerSchema } from '../Divider/schema';
import { LandingPageCustomProps } from './LandingPageCustom';
import { faqsSchema } from '../FAQs';
import { footerImageLinksSchema } from '../FooterImageLinks';
import { getStartedBoxSchema } from '../GetStartedBox';
import { imageContent1UpSchema } from '../ImageContent1Up';
import { logoGridSchema } from '../LogoGrid';
import { merchCarouselSchema } from '../MerchCarousel';
import { promoBannerSchema } from '../PromoBanner';
import { reasonsToSignUpSchema } from '../ReasonsToSignUp';
import { shoppableEditorialSchema } from '../ShoppableEditorial';
import { tripleBlockSchema } from '../TripleBlock';
import { stylistModuleSchema } from '../StylistModule';
import { videoFullBleedHeroSchema, videoHalfScreenHeroSchema } from '../VideoLayout';
import { trigallHeroSchema } from '../TrigallHero';
import { contentBlockSchema } from '../ContentBlock/schema';
const mapModules = (modules: LandingPageCustom['modules']): LandingPageCustomProps['modules'] => {
  return modules.map(module => {
    if ('business_line_carousel' in module) {
      return {
        type: 'businessLineCarousel',
        props: businessLineCarouselSchema.parse(module.business_line_carousel)
      };
    }
    if ('image_half_screen_hero' in module) {
      return {
        type: 'imageHalfScreenHero',
        props: imageHalfScreenHeroSchema.parse(module.image_half_screen_hero)
      };
    }
    if ('content_gallery' in module) {
      return {
        type: 'contentGallery',
        props: contentGallerySchema.parse(module.content_gallery)
      };
    }
    if ('content_block' in module) {
      return {
        type: 'contentBlock',
        props: contentBlockSchema.parse(module.content_block.content)
      };
    }
    if ('divider' in module) {
      return {
        type: 'divider',
        props: dividerSchema.parse(module.divider)
      };
    }
    if ('faqs' in module) {
      return {
        type: 'faqs',
        props: faqsSchema.parse(module.faqs)
      };
    }
    if ('footer_image_links' in module) {
      return {
        type: 'footerImageLinks',
        props: footerImageLinksSchema.parse(module.footer_image_links)
      };
    }
    if ('get_started' in module) {
      return {
        type: 'getStarted',
        props: getStartedBoxSchema.parse(module.get_started)
      };
    }
    if ('image_content_1up' in module) {
      return {
        type: 'imageContent1Up',
        props: imageContent1UpSchema.parse(module.image_content_1up)
      };
    }
    if ('logo_grid' in module) {
      return {
        type: 'logoGrid',
        props: logoGridSchema.parse(module.logo_grid)
      };
    }
    if ('merch_carousel' in module) {
      return {
        type: 'merchCarousel',
        props: merchCarouselSchema.parse(module.merch_carousel)
      };
    }
    if ('promo_banner' in module) {
      return {
        type: 'promoBanner',
        props: promoBannerSchema.parse(module.promo_banner)
      };
    }
    if ('reasons_to_signup' in module) {
      return {
        type: 'reasonsToSignUp',
        props: reasonsToSignUpSchema.parse(module.reasons_to_signup)
      };
    }
    if ('shoppable_editorial' in module) {
      return {
        type: 'shoppableEditorial',
        props: shoppableEditorialSchema.parse(module.shoppable_editorial)
      };
    }
    if ('stylist_module' in module) {
      return {
        type: 'stylistModule',
        props: stylistModuleSchema.parse(module.stylist_module)
      };
    }
    if ('triple_block' in module) {
      return {
        type: 'tripleBlock',
        props: tripleBlockSchema.parse(module.triple_block)
      };
    }
    if ('trigall_hero' in module) {
      return {
        type: 'trigallHero',
        props: trigallHeroSchema.parse(module.trigall_hero)
      };
    }
    if ('video_full_bleed_hero' in module) {
      return {
        type: 'videoFullBleedHero',
        props: videoFullBleedHeroSchema.parse(module.video_full_bleed_hero)
      };
    }
    if ('video_half_screen_hero' in module) {
      return {
        type: 'videoHalfScreenHero',
        props: videoHalfScreenHeroSchema.parse(module.video_half_screen_hero)
      };
    }
    return {
      type: 'notSupported',
      props: null
    };
  });
};
export const landingPageCustomSchema = landing_page_custom.transform(data => ({
  seoData: seoDataSchema.parse(data.seo_data),
  modules: mapModules(data.modules)
}));